import { Link } from "react-router-dom";
import { useCookieConsentContext } from "@/contexts/CookieConsentContext";
import { Instagram, Calendar } from "lucide-react";

const Footer = () => {
  const { openCookiePreferences } = useCookieConsentContext();

  return (
    <footer className="bg-card border-t border-border py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-5 gap-8 mb-8">
          <div>
            <h3 className="font-playfair text-lg font-bold text-foreground mb-4">
              Nos régions
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/lausanne" className="text-muted-foreground hover:text-primary transition-colors">
                  Lausanne
                </Link>
              </li>
              <li>
                <Link to="/geneve" className="text-muted-foreground hover:text-primary transition-colors">
                  Genève
                </Link>
              </li>
              <li>
                <Link to="/fribourg" className="text-muted-foreground hover:text-primary transition-colors">
                  Fribourg
                </Link>
              </li>
              <li>
                <Link to="/neuchatel" className="text-muted-foreground hover:text-primary transition-colors">
                  Neuchâtel
                </Link>
              </li>
              <li>
                <Link to="/sion" className="text-muted-foreground hover:text-primary transition-colors">
                  Sion
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-playfair text-lg font-bold text-foreground mb-4">
              Comparatifs
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/comparatif/piktable-vs-mylocalina" className="text-muted-foreground hover:text-primary transition-colors">
                  vs MyLOCALINA
                </Link>
              </li>
              <li>
                <Link to="/comparatif/piktable-vs-foratable" className="text-muted-foreground hover:text-primary transition-colors">
                  vs Foratable
                </Link>
              </li>
              <li>
                <Link to="/comparatif/piktable-vs-aleno" className="text-muted-foreground hover:text-primary transition-colors">
                  vs aleno
                </Link>
              </li>
              <li>
                <Link to="/comparatif/piktable-vs-thefork" className="text-muted-foreground hover:text-primary transition-colors">
                  vs TheFork
                </Link>
              </li>
              <li>
                <Link to="/comparatif/piktable-vs-opentable" className="text-muted-foreground hover:text-primary transition-colors">
                  vs OpenTable
                </Link>
              </li>
              <li>
                <Link to="/comparatif/piktable-vs-zenchef" className="text-muted-foreground hover:text-primary transition-colors">
                  vs Zenchef
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-playfair text-lg font-bold text-foreground mb-4">
              Solution
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/pricing" className="text-muted-foreground hover:text-primary transition-colors">
                  Tarifs
                </Link>
              </li>
              <li>
                <a href="/#comment" className="text-muted-foreground hover:text-primary transition-colors">
                  Comment ça marche
                </a>
              </li>
              <li>
                <Link to="/blog" className="text-muted-foreground hover:text-primary transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-playfair text-lg font-bold text-foreground mb-4">
              Entreprise
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/legal" className="text-muted-foreground hover:text-primary transition-colors">
                  Mentions légales
                </Link>
              </li>
              <li>
                <a href="mailto:contact@piktable.ch" className="text-muted-foreground hover:text-primary transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <button 
                  onClick={openCookiePreferences}
                  className="text-muted-foreground hover:text-primary transition-colors text-left"
                >
                  Gérer les cookies
                </button>
              </li>
              <li>
                <a 
                  href="https://www.instagram.com/piktable/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary transition-colors inline-flex items-center gap-2"
                >
                  <Instagram className="h-4 w-4" />
                  Instagram
                </a>
              </li>
              <li>
                <a 
                  href="https://calendly.com/maxdmnt/piktable" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary transition-colors inline-flex items-center gap-2"
                >
                  <Calendar className="h-4 w-4" />
                  Réserver un appel
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-playfair text-lg font-bold text-foreground mb-4">
              À propos
            </h3>
            <p className="text-muted-foreground text-sm">
              Solution développée à Lausanne pour les restaurants de Suisse romande 🇨🇭
            </p>
          </div>
        </div>

        <div className="border-t border-border pt-6 text-center text-muted-foreground text-sm">
          <p>
            © 2026 Piktable - Développé par{" "}
            <span className="font-semibold">Reversed Sàrl</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
